import { Link } from 'src/navigation';
import kebabCase from 'lodash/kebabCase';
import pushToDataLayer from 'lib/analytics/pushToDataLayer';
import styles from './sub-nav-item.module.scss';
import { useLocale } from 'next-intl';
import { ensureEngageLocale } from 'lib/engage';

const SubNavItem = ({ url, text, parentText }: IProps) => {
	const locale = useLocale();
	const handleNavItemClick = () => {
		const menu_category_1 = parentText;
		const menu_category_2 = text;
		pushToDataLayer({
			event: 'menu_click',
			menu_category_1,
			menu_category_2,
			menu_item_location: 'header',
		});
	};

	return (
		<li className={styles.linkWrapper}>
			<Link
				prefetch={false}
				onClick={handleNavItemClick}
				className={styles.link}
				href={ensureEngageLocale(url, locale)}
				data-analytics-id={`subnav-item-${kebabCase(parentText)}-${kebabCase(text)}`}
			>
				{text}
			</Link>
		</li>
	);
};

interface IProps {
	parentText: string;
	text: string;
	url: string;
}

export default SubNavItem;
